export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('vue:error', (error, instance, info) => {
        // Suppress vnode destructuring errors during route transitions
        if (error?.message?.includes('Cannot destructure property') && error?.message?.includes('vnode')) {
            console.warn('Suppressed vnode error during route transition:', error.message)
            return
        }
        
        if (process.env.NODE_ENV !== 'production') {
            console.error('Vue error:', error, info)
        }
    })
    
    // Handle component errors during route transitions
    nuxtApp.hook('page:transition:finish', () => {
        // Clear any stale component references
        if (typeof window !== 'undefined' && window.__NUXT__) {
            // Force cleanup of any cached components
        }
    })
})
